module.exports = __webpack_public_path__ + "static/media/glasgowunilogo.97b3fa54.png";